module.exports = __webpack_public_path__ + "media/images/flags/vn-b05bb20cdd1fa039f12f1b6abe8de1a3.svg";